import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { tap } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.auth.headers) {
      request = request.clone({
        setHeaders: this.auth.headers,
        url: request.url.replace(AuthService.USER_UID, this.auth.headers.user_uid)
      });
    }
    return next.handle(request).pipe(
      tap(
        () => {},
        err => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              this.auth.logout();
            }
          }
        },
      ),
    );
  }
}
